import styles from "./Products.module.scss"
import Headphones from '../../../../../../../assets/images/product-image-headphones.png'

const Products = () => {

  const data = [
    {
      image: Headphones,
      name: "Blue Colored Headphones",
      id: "#123456789",
      selectedKeyWords: 24,
    },
    {
      image: Headphones,
      name: "Blue Colored Headphones",
      id: "#123456789",
      selectedKeyWords: 24,
    },
    {
      image: Headphones,
      name: "Blue Colored Headphones",
      id: "#123456789",
      selectedKeyWords: 24,
    },
    {
      image: Headphones,
      name: "Blue Colored Headphones",
      id: "#123456789",
      selectedKeyWords: 24,
    },
    {
      image: Headphones,
      name: "Blue Colored Headphones",
      id: "#123456789",
      selectedKeyWords: 24,
    },
    {
      image: Headphones,
      name: "Blue Colored Headphones",
      id: "#123456789",
      selectedKeyWords: 24,
    },
  ]

  return (
    <section>
      <div className={styles["heading"]}>Products</div>

      {data.map((item, index) => (
        <div className="d-flex gap-2 border-bottom border-secondary-subtle py-2" key={index}>
          <div>
            <img src={item.image} alt="" width={56} height={57} />
          </div>
          <div className="fw-medium">
            <div className={styles.name}>{item.name}</div>
            <div className={styles.subcontent}>Product ID: {item.id}</div>
            <div className={styles.subcontent}>Selected key words: {item.selectedKeyWords}</div>
          </div>
        </div>
      ))}
    </section>
  )
}

export default Products
